import cloneDeep from 'lodash.clonedeep'

const pipe = (...fns) => x => fns.reduce((v, f) => f(v), x)

const flattenEcuPropertiesObject = (fileData) => {
  if (![1, 2].includes(fileData.selectedReport)) return fileData
  const newFileData = cloneDeep(fileData)
  const ecus = newFileData?.reportData?.ecuProperties?.ecus
  if (ecus && typeof ecus === 'object') {
    newFileData.reportData.ecuProperties.ecus = ecus.map(x => x.id)
  }
  return newFileData
}

const flattenFreezeFramesObjects = (fileData) => {
  if (![1].includes(fileData.selectedReport)) return fileData
  const newFileData = cloneDeep(fileData)
  const signals = newFileData?.reportData?.signals

  newFileData.reportData.signals = signals.map(x => x.id)

  return newFileData
}

const flattenProductQualityObjects = (fileData) => {
  if (![4].includes(fileData.selectedReport)) return fileData
  const newFileData = cloneDeep(fileData)
  const partDescriptionObjects = newFileData?.reportData?.partDescriptionObjects
  const partObjects = newFileData?.reportData?.partObjects

  newFileData.reportData.partDescriptionObjects = partDescriptionObjects.map(x => x.id)
  newFileData.reportData.partObjects = partObjects.map(x => x.id)

  return newFileData
}

const flattenOperationalVariablesObjects = (fileData) => {
  if (![3].includes(fileData.selectedReport)) return fileData
  const newFileData = cloneDeep(fileData)
  const ecuFamilies = newFileData?.reportData?.ecuFamilies
  const variableTypes = newFileData?.reportData?.variableTypes

  newFileData.reportData.ecuFamilies = ecuFamilies.map(x => x.id)
  newFileData.reportData.variableTypes = variableTypes.map(x => x.id)

  return newFileData
}

const compatibilityMapFile = (fileData) => {
  const version = fileData?.version || 1.0
  let compatibleData = fileData

  if (version < 1.1) {
    compatibleData = pipe(
      flattenEcuPropertiesObject,
      flattenFreezeFramesObjects,
      flattenProductQualityObjects,
      flattenOperationalVariablesObjects
    )(compatibleData)
  }
  return compatibleData
}

export default compatibilityMapFile
